import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clock',
  templateUrl: './clock.component.html',
  styleUrls: ['./clock.component.css']
})
export class ClockComponent implements OnInit {

  public date:Date= new Date();
  constructor() { }

  ngOnInit(): void {
    setInterval(()=>{
      this.date = new Date();
    },1000);
  }

}
